import React, { Component } from 'react'
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { showCorporateKitsList, doCorporateKitsListingRes } from "../../../action/CorporateKitsListAction";
import { showCorporateCustomizeProductList, doCorporateCustomizeProductListingRes } from "../../../action/CorporateCustomizeProductListAction";
import './CorporateTab.css'
import CorporateLayoutWrapper from '../../../component/CorporateLayoutWrapper/'
import CookieConsent from "react-cookie-consent";
import Footer from '../../../component/Footer/Footer';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Skeleton from 'react-loading-skeleton';
import loaderImg from '../../../assets/images/loader-example.gif';
import Loader from 'react-loader-advanced';

class CorporateTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: "giftKids",
            kidsProductData: [],
            customizeKidsData: [],
            checkedValue: false,
            arrChecked: [],
            isLoader: false,
        }
    }

    componentDidMount() {
        const kitsData = {
            user_id: localStorage.getItem('userId')
        }
        this.setState({
            isLoader: true
        })
        this.props.showCorporateKitsList(kitsData)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.doCorporateKitsListingRes && nextProps.doCorporateKitsListingRes.user) {
            if (nextProps.doCorporateKitsListingRes.user && nextProps.doCorporateKitsListingRes.user.CorporateKitsListRes) {
                if (nextProps.doCorporateKitsListingRes.user.CorporateKitsListRes && nextProps.doCorporateKitsListingRes.user.CorporateKitsListRes.results === true) {
                    this.setState({
                        kidsProductData: nextProps.doCorporateKitsListingRes.user.CorporateKitsListRes.data,
                        isLoader: false
                    })
                } else {
                    this.setState({
                        isLoader: false
                    })
                }
            }
        }

        if (nextProps.doCorporateCustomizeProductListingRes && nextProps.doCorporateCustomizeProductListingRes.user) {
            if (nextProps.doCorporateCustomizeProductListingRes.user && nextProps.doCorporateCustomizeProductListingRes.user.CorporateCustomizeProductListRes) {
                if (nextProps.doCorporateCustomizeProductListingRes.user.CorporateCustomizeProductListRes && nextProps.doCorporateCustomizeProductListingRes.user.CorporateCustomizeProductListRes.results === true) {
                    this.setState({
                        customizeKidsData: nextProps.doCorporateCustomizeProductListingRes.user.CorporateCustomizeProductListRes.data,
                        isLoader: false
                    })
                } else {
                    this.setState({
                        isLoader: false
                    })
                }
            }
        }
    }

    changeTab = (type) => {
        if (type === "giftKids") {
            this.setState({
                activeTab: "giftKids"
            })
        } else {
            this.setState({
                activeTab: "customizeGiftKids"
            })

            const custData = {
                user_id: localStorage.getItem('userId')
            }
            this.setState({
                isLoader: true
            })
            this.props.showCorporateCustomizeProductList(custData)
        }
    }




    dataSend = () => {
        this.props.history.push('/corporate-product-update')
    }

    productViewClick = (item) => {
        this.props.history.push('/corporate-productview/' + item.kit_id + '/' + item.slug)

    }

    corporateViewClick = (item) => {
        console.log('itemName', item)
        if (item.cat_id === "t-shirt") {
            this.props.history.push('/corporate-men-customize/' + item.product_id + '/' + item.slug)
        } else if (item.cat_id === "keychain" || item.cat_id === "mug" || item.cat_id === "bottle") {
            this.props.history.push('/corporate-customize-view/' + item.product_id + '/' + item.slug)
        }

    }

    render() {
        const spinner = <span><img src={loaderImg} alt="" /></span>;
        return (
            <React.Fragment>

                <div className="page-wrapper">

                    <CookieConsent
                        location="bottom"
                        buttonText="ALLOW COOKIES"
                        cookieName="myAwesomeCookieName2"
                        style={{ background: "#fff" }}
                        buttonStyle={{ color: "#fff", fontSize: "13px", padding: "15px", margin: "20px", marginRight: '250px', background: '#1b75bc' }}
                        expires={150}
                    >
                        <div className="cookie-disply-margin">
                            <p className="cookie-p dis-cookie-flex">We use cookies to collect and analyse information on site performance and usage, to provide social media features and to enhance and customise content and advertisements. </p>
                            <span className="cookie-learn"><a href="https://www.cookiehub.com/about-cookies?en" rel="noopener" target="_self" className="cookie-learn">Learn more</a></span>
                        </div>
                    </CookieConsent>
                    <CorporateLayoutWrapper />

                    <Loader show={this.state.isLoader} message={spinner}>

                        <main className="main main-container">
                            <div className="home-top-container">
                                <div className="container align-center">
                                    <div className='col-md-3 max-widt'>
                                        <div className="toggle-btn-container disp-flex">
                                            <div className={`toggle-tab ${this.state.activeTab === 'giftKids' ? 'active-tab' : null}`}
                                                onClick={() => this.changeTab("giftKids")}
                                            >
                                                Gift Kits
                                            </div>
                                            <div className={`toggle-tab ${this.state.activeTab === 'customizeGiftKids' ? 'active-tab' : null}`}
                                                onClick={() => this.changeTab("customizeGiftKids")}
                                            >
                                                Customize Gift Kits
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="mb-5"></div>
                                <div className='container'>
                                    <div className="row row-sm">
                                        {
                                            this.state.activeTab === 'giftKids' &&
                                            <div>
                                                {this.state.kidsProductData && this.state.kidsProductData.map((item, i) =>
                                                    <div className="col-6 col-md-4 col-xl-3" key={i}>
                                                        <div className="product-default">
                                                            <figure>

                                                                <LazyLoadImage
                                                                    alt={item.title + '@ ₹.' + item.sale_price + '/- only'}
                                                                    effect="blur"
                                                                    src={item.photo}
                                                                    onClick={() => this.productViewClick(item)}
                                                                    className="pointer"
                                                                />
                                                            </figure>
                                                            <div className="product-details">

                                                                {/* End .product-container */}
                                                                <h2 className="product-title">
                                                                    {
                                                                        item ?
                                                                            <span className="product-name">{item.title}
                                                                            </span>
                                                                            :
                                                                            <Skeleton width={50} />
                                                                    }
                                                                </h2>
                                                                <div className="price-box">
                                                                    <span className="old-price">
                                                                        <i className="fa fa-rupee-sign" aria-hidden="true"></i>
                                                                        {item.price || <Skeleton />}.00
                                                                    </span>
                                                                    <span className="product-price pl-2">
                                                                        <i className="fa fa-rupee-sign" aria-hidden="true"></i>
                                                                        {item.sale_price || <Skeleton />}.00
                                                                    </span>
                                                                </div>
                                                                <div className="product-action">
                                                                    <button className="btn-icon btn-add-cart show-color text-white " data-toggle="modal" data-target="#addCartModal" onClick={() => this.productViewClick(item)}>Show Details</button>
                                                                    {/* </Link> */}
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        }
                                        {
                                            this.state.activeTab === 'customizeGiftKids' &&
                                            <div>
                                                <div className='row row-sm'>
                                                    {this.state.customizeKidsData && this.state.customizeKidsData.map((item, i) =>
                                                        <div className="col-6 col-md-4 col-xl-3 marg_top_10" key={i} >
                                                            <div className="product-default card-item">

                                                                <figure>

                                                                    <LazyLoadImage
                                                                        alt={item.name + '@ ₹.' + item.sale_price + '/- only'}
                                                                        effect="blur"
                                                                        src={item.photo}
                                                                        className="pointer"
                                                                        onClick={() => this.corporateViewClick(item)}

                                                                    />
                                                                </figure>
                                                                <div className="product-details">

                                                                    {/* End .product-container */}
                                                                    <h2 className="product-title mrg-b-0">
                                                                        {
                                                                            item ?
                                                                                <span className="product-name">{item.name}
                                                                                </span>
                                                                                :
                                                                                <Skeleton width={50} />
                                                                        }

                                                                    </h2>
                                                                    <em>{item.subName}</em>
                                                                    <div className="price-box mt-3">
                                                                        <span className="old-price">
                                                                            <i className="fa fa-rupee-sign" aria-hidden="true"></i>
                                                                            {item.price || <Skeleton />}.00
                                                                        </span>
                                                                        <span className="product-price pl-2">
                                                                            <i className="fa fa-rupee-sign" aria-hidden="true"></i>
                                                                            {item.sale_price || <Skeleton />}.00
                                                                        </span>
                                                                    </div>
                                                                    <div className="product-action">
                                                                        <button className="btn-icon btn-add-cart show-color text-white " data-toggle="modal" data-target="#addCartModal" onClick={() => this.corporateViewClick(item)}>Show Details</button>
                                                                        {/* </Link> */}
                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </div>
                                                    )}

                                                </div>

                                            </div>
                                        }
                                    </div>
                                </div>


                                {/* </div> */}


                                {/* End .container */}
                            </div>
                            <div className="mb-5"></div>
                        </main>
                    </Loader>

                </div>
                <Footer />
            </React.Fragment>
        )
    }
}

CorporateTab.propTypes = {
    doCorporateKitsListingRes: PropTypes.any,
    doCorporateCustomizeProductListingRes: PropTypes.any
}

const mapStateToProps = createStructuredSelector({
    doCorporateKitsListingRes: doCorporateKitsListingRes,
    doCorporateCustomizeProductListingRes: doCorporateCustomizeProductListingRes
})

function mapDispatchToProps(dispatch) {
    return {
        showCorporateKitsList: (data) => dispatch(showCorporateKitsList(data)),
        showCorporateCustomizeProductList: (data) => dispatch(showCorporateCustomizeProductList(data))
    }
}


const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(CorporateTab)
